import { render, staticRenderFns } from "./ArticlePickerModal.vue?vue&type=template&id=6a566e56&scoped=true&"
import script from "./ArticlePickerModal.vue?vue&type=script&lang=js&"
export * from "./ArticlePickerModal.vue?vue&type=script&lang=js&"
import style0 from "./ArticlePickerModal.vue?vue&type=style&index=0&id=6a566e56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a566e56",
  null
  
)

export default component.exports